import baseService from './baseService';

export function login(body) {
  return baseService.post('/auth/login', body);
}

export function checkAuthToken() {
  return baseService.get('/auth/check');
}
